import {createRouter, createWebHistory} from "vue-router";

const productionRoutes = [
    {
        name: "auth",
        path: "/auth",
        component: () => import("@/components/SAuthPage.vue")
    },
    {
        name: "backoffice",
        path: "/backoffice",
        component: () => import("@/components/SBackofficePage.vue")
    },
    {
        name: "ws-chooser",
        path: "/chooser",
        component: () => import("@/components/SWorkspaceChooserPage.vue")
    },
    {
        name: "ws",
        path: "/ws/:wsId?",
        component: () => import("@/components/SWorkspace.vue"),
        children: [
            {
                path: "home",
                name: "home",
                component: () => import("@/components/home/SHome.vue")
            },
            {
                path: "reports",
                name: "reports",
                component: () => import("@/components/report/SReports.vue")
            },
            {
                path: "my-reports",
                name: "my-reports",
                component: () => import("@/components/report/SReports.vue")
            },
            {
                path: "shared-reports",
                name: "shared-reports",
                component: () => import("@/components/report/SReports.vue")
            },
            {
                path: "vaults",
                name: "vaults",
                component: () => import("@/components/vault/SVaults.vue")
            },
            {
                path: "my-vaults",
                name: "my-vaults",
                component: () => import("@/components/vault/SVaults.vue")
            },
            {
                path: "shared-vaults",
                name: "shared-vaults",
                component: () => import("@/components/vault/SVaults.vue")
            },
            {
                path: "report/:reportId?",
                name: "report",
                strict: true,
                component: () => import("@/components/report/SReportViewer.vue")
            },
            {
                path: "vault/:vaultId?",
                name: "vault",
                strict: true,
                component: () => import("@/components/vault/SVault.vue")
            },
        ]
    },
    {
        name: "analysis-param-tester",
        path: "/tester/analysis-param",
        component: () => import("@/components/report/SAnalysisParamTesterPage.vue")
    },
    {
        path: "/easter",
        component: () => import("@/components/generic/SPageEasterEgg.vue")
    },
    {
        name: "error",
        path: "/error",
        component: () => import("@/components/generic/SErrorPage.vue")
    },
    {
        path: "/:catchAll(.*)",
        component: () => import("@/components/generic/SErrorPage.vue")
    }
];

let routes;
if (process.env.NODE_ENV === "development") {
    routes = [
        {
            name: "landing",
            path: "",
            component: () => import("@/components/SLandingPage.vue")
        }
    ].concat(productionRoutes);
} else {
    routes = productionRoutes;
}

const router = createRouter({
    // Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(process.env.BASE_URL),
    routes: routes
});
export default router;
